import { LOCATION_CHANGE } from 'react-router-redux';
import { call, select } from 'redux-saga/effects';

import * as StatsConstants from '../../constants';
import * as D from '../../deps';
import * as StatsUtils from '../../utils';
import * as StatsWorkers from '../workers';
import * as AudioPlayerStatsWorkers from '../workers/audioPlayer';
import * as BackstageStatsWorkers from '../workers/backstage';
import * as BufferingWorkers from '../workers/buffering';
import * as TTMWorkers from '../workers/timeToMusic';

export default [
  {
    actionType: D.Constants.UseCases.ActionTypes.LOG_EVENTS,
    concur: 'takeEvery',
    handler: function* handler(action) {
      yield call(StatsWorkers.logEvents, action.payload);
    },
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.EXPIRE_VALUE_EXCHANGE_REWARD,
    concur: 'takeEvery',
    handler: StatsWorkers.onExpireValueExchangeReward,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.STATION_STARTED,
    concur: 'takeEvery',
    handler: StatsWorkers.onStartStation,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.PAUSE_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onPauseTrack,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_REPLAY_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onReplayTrack,
  },
  {
    actionType: D.Constants.Api.ApiActions.SEARCH_TERM_UPDATE,
    concur: 'takeLatest',
    handler: StatsWorkers.onSearchTermUpdate,
  },
  {
    actionType: D.Constants.Search.SearchActions.SEARCH_UI_UPDATE,
    concur: 'takeLatest',
    handler: StatsWorkers.onSearchUIUpdate,
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.SEARCH_SUCCESS,
      D.Constants.Api.ApiActions.SOD_SEARCH_SUCCESS,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.onSearchResultsUpdate,
  },
  {
    actionType: D.Constants.Search.SearchActions.FILTER_CHANGED,
    concur: 'takeEvery',
    handler: StatsWorkers.onFilterChange,
  },
  {
    actionType: D.Constants.Api.ApiActions.SEARCH_AUTOCOMPLETE_SUCCESS,
    concur: 'takeEvery',
    handler: StatsWorkers.onSearchAutoCompleteResultsUpdate,
  },
  {
    actionType: D.Constants.Search.SearchActions.SEARCH_SELECT,
    concur: 'takeEvery',
    handler: StatsWorkers.onSearchSelect,
  },
  {
    actionType: D.Constants.Search.SearchActions.SEARCH_CLEAR,
    concur: 'takeEvery',
    handler: StatsWorkers.onSearchClear,
  },
  {
    actionType: D.Constants.Search.SearchActions.SEARCH_SCROLL,
    concur: 'takeEvery',
    handler: StatsWorkers.onSearchResultsScroll,
  },
  {
    actionType: D.Constants.Search.SearchActions.SEARCH_RESULTS_RENDERED,
    concur: 'takeEvery',
    handler: StatsWorkers.logSearchResultsRendered,
  },
  {
    actionType: D.Constants.ListenerExternals.Actions.LOGIN_VIEW_UPDATED,
    concur: 'takeEvery',
    handler: StatsWorkers.onWebViewModeInteraction,
  },
  {
    actionType: D.Constants.Api.ApiActions.LOGIN_SUCCESS,
    concur: 'takeEvery',
    handler: StatsWorkers.onLoginSuccess,
  },
  {
    actionType: D.Constants.ListenerExternals.Actions.LOGIN_FAILED,
    concur: 'takeEvery',
    handler: StatsWorkers.onWebViewModeInteraction,
  },
  {
    actionType: D.Constants.ListenerExternals.Actions.REGISTER_VIEW_UPDATED,
    concur: 'takeEvery',
    handler: StatsWorkers.onWebViewModeInteraction,
  },
  {
    actionType: D.Constants.ListenerExternals.Actions.REGISTER,
    concur: 'takeEvery',
    handler: function* handler() {
      yield call(StatsWorkers.onWebRegistrationEvent, {
        registrationEventAction: StatsConstants.WebRegistrationEvents.SIGN_UP_ATTEMPTED,
      });
    },
  },
  {
    actionType: D.Constants.RegisterActions.RegisterActions.REGISTER_BLOCKED,
    concur: 'takeEvery',
    handler: function* handler() {
      yield call(StatsWorkers.onWebRegistrationEvent, {
        registrationEventAction: StatsConstants.WebRegistrationEvents.REGISTRATION_FAILED_UNDER_AGE,
      });
    },
  },
  {
    actionType: D.Constants.Api.ApiActions.REGISTER_SUCCESS,
    concur: 'takeEvery',
    handler: StatsWorkers.onRegisterSuccess,
  },
  {
    actionType: D.Constants.Api.ApiActions.REGISTER_FAIL,
    concur: 'takeEvery',
    handler: StatsWorkers.onRegisterFail,
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_ADLIST_ATTEMPT,
    concur: 'takeEvery',
    handler: StatsWorkers.onGetAdlist,
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_ADLIST_FAIL,
    concur: 'takeEvery',
    handler: StatsWorkers.onGetAdlistFail,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.STATION_CREATED,
    concur: 'takeEvery',
    handler: StatsWorkers.onStationCreated,
  },
  {
    actionType: D.Constants.External.ExternalActions.RELAY_EXTERNAL_API_CALL,
    concur: 'takeEvery',
    handler: StatsWorkers.onExternalApiEvent,
  },
  {
    actionType: 'IDLE_MONITOR_UPDATE', // TODO: WEBCA-2652 - fix this magic string
    concur: 'takeEvery',
    handler: StatsWorkers.onIdleMonitorUpdate,
  },
  {
    actionType: [
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_REQUEST,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_RESPONSE,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_ERROR_RESPONSE,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_IAS_PET_REQUEST,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_IAS_PET_RESPONSE,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_START_RENDER,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_FINISH_RENDER,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_DISMISSED,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_IAS_GPT_SCRIPT_LOAD_FAIL,
      D.Constants.Analytics.ActionTypes.WEB_DISPLAY_AD_IAS_PET_SCRIPT_LOAD_FAIL,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.onWebDisplayAdLifecycleEvent,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.ADD_VARIETY,
    concur: 'takeEvery',
    handler: function* handler(action) {
      yield call(StatsWorkers.logEvents, [
        {
          eventName: StatsConstants.Events.ADD_VARIETY,
          eventData: action.payload,
        },
      ]);
    },
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.DELETE_STATION,
    concur: 'takeEvery',
    handler: StatsWorkers.onStationDeleted,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_PREMIUM_PLAYLIST_UNLOCKED,
    concur: 'takeEvery',
    handler: StatsWorkers.logPremiumPlaylistUnlocked,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_PREMIUM_PLAYLIST_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.logPremiumPlaylistCoachmark,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.SHUFFLE_EDIT,
    concur: 'takeEvery',
    handler: function* handler(action) {
      yield call(StatsWorkers.logEvents, [
        {
          eventName: StatsConstants.Events.QUICK_MIX_EDIT,
          eventData: action.payload,
        },
      ]);
    },
  },
  {
    actionType: LOCATION_CHANGE,
    concur: 'takeEvery',
    handler: StatsWorkers.onLocationChange,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_TRACK_END_STATION,
    concur: 'takeEvery',
    handler: function* handler(action) {
      yield call(StatsWorkers.onTrackEndStation, action.payload.reason, action.payload.track);
    },
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_TRACK_END,
    concur: 'takeEvery',
    handler: function* handler(action) {
      yield call(StatsWorkers.onTrackEnd, action.payload);
    },
  },
  {
    actionType: [
      D.Constants.Collection.CollectionActions.SET_COLLECTION_CURRENT_FILTER_SORT,
      D.Constants.MyStations.MyStationsActions.SET_MY_STATIONS_DISPLAY_SETTINGS,
      D.Constants.MyStations.MyStationsActions.SET_MY_STATIONS_DISPLAY,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.onCollectionListSorted,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_WEB_VIEW_MODE_EVENT,
    concur: 'takeEvery',
    handler: StatsWorkers.onWebViewModeInteraction,
  },
  {
    actionType: [
      // dispatched directly from component
      D.Constants.ViewActions.SHOWED_BACKSTAGE_PAGE,
      D.Constants.Integrations.ActionTypes.COMPONENT_VIEWED,
      D.Constants.Integrations.ActionTypes.COMPONENT_CLICKED,
      D.Constants.SourceCard.ActionTypes.SOURCE_CARD_OPENED,
      D.Constants.SourceCard.ActionTypes.SOURCE_CARD_OPTION_CLICKED,
      // dispatched from mediator
      D.Constants.Analytics.ActionTypes.LOG_BACKSTAGE_EVENT,
    ],
    concur: 'takeEvery',
    handler: BackstageStatsWorkers.onBackstageEvent,
  },
  {
    actionType: StatsConstants.Events.WEB_REGISTRATION,
    concur: 'takeEvery',
    handler: function* handler(action) {
      yield call(StatsWorkers.onWebRegistrationEvent, {
        registrationEventAction: action.payload.registrationEvent,
      });
    },
  },
  {
    actionType: D.Constants.App.AppActions.APPLICATION_INITIALIZE,
    concur: 'takeOnce',
    handler: StatsWorkers.onApplicationInitialize,
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REGISTER_SKIP_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onSkipTrack,
  },
  {
    actionType: [
      D.Constants.Overlay.OVERLAY_ACTIONS.CHECK_AND_MAYBE_OPEN_OVERLAY,
      D.Constants.Api.ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS,
      D.Constants.Analytics.ActionTypes.ADD_COLLECTION_ITEM,
      D.Constants.Playback.ActionTypes.SET_PLAYLIST,
      D.Constants.Analytics.ActionTypes.STATION_STARTED,
      D.Constants.Analytics.ActionTypes.ENTER_REDEEM_FLOW_FOR_URL,
    ],
    concur: 'takeEvery',
    handler: function* handler(action) {
      const state = D.getStore().getState();
      const { partnerId, correlationId } = yield select(StatsUtils.getInboundTrackingDataFromState);

      if (!action.data) {
        // TODO-PAYLOAD: WEBCA-2505
        action.data = action.payload;
      }

      if (partnerId && correlationId) {
        yield call(
          StatsWorkers.logInboundLinkEvent,
          partnerId,
          correlationId,
          state,
          false,
          action,
        );
      }
    },
  },
  {
    actionType: D.Constants.ViewActions.OPEN_SESSION_HISTORY,
    concur: 'takeEvery',
    handler: StatsWorkers.onOpenSessionHistory,
  },
  {
    actionType: D.Constants.ViewActions.CLOSE_SESSION_HISTORY,
    concur: 'takeEvery',
    handler: StatsWorkers.onCloseSessionHistory,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_SKIP_LIMIT_STATS,
    concur: 'takeEvery',
    handler: StatsWorkers.skipLimit,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_BROWSER_AUTOPLAY_PLAYBACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onBrowserAutomaticPlayback,
  },
  {
    actionType: D.Constants.Payments.Actions.LOG_UPGRADE_PAGE_EVENT,
    concur: 'takeEvery',
    handler: StatsWorkers.onUpgradePageEvent,
  },
  {
    actionType: D.Constants.Payments.Actions.UPGRADE_CONFIRMATION,
    concur: 'takeEvery',
    handler: StatsWorkers.onUpgradeConfirmationEvent,
  },
  {
    actionType: D.Constants.Payments.Actions.UPDATING_BILLING_INFO,
    concur: 'takeEvery',
    handler: StatsWorkers.onUpdateBillingInfo,
  },
  {
    actionType: D.Constants.Payments.Actions.TOGGLE_SWITCHING_PLANS,
    concur: 'takeEvery',
    handler: StatsWorkers.onToggleSwitchingPlans,
  },
  {
    actionType: D.Constants.Api.ApiActions.FETCH_STATIONS_SUCCESS,
    concur: 'takeOnce',
    handler: StatsWorkers.recordInitialTTM,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.AUDIO_TRACK_PLAYBACK_STATS,
    concur: 'takeEvery',
    handler: StatsWorkers.onAudioTrackPlayback,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.TRACK_END_ERROR,
    concur: 'takeEvery',
    handler: StatsWorkers.onTrackEndError,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_AB_EXPERIMENT_DIVERSION_POINT,
    concur: 'takeEvery',
    handler: StatsWorkers.logAbExperimentDiversionPointEvent,
  },
  {
    actionType: StatsConstants.Events.PLAYED_PA_WELCOME_AUDIO,
    concur: 'takeEvery',
    handler: StatsWorkers.logPlayedPremiumAccessWelcomeAudio,
  },
  {
    actionType: StatsConstants.Events.OPENED_LTUX_PA_UPSELL_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.logOpenedLTUXPAUpsellCoachmark,
  },
  {
    actionType: StatsConstants.Events.CLICKED_LTUX_PA_UPSELL_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.logClickedLTUXPAUpsellCoachmark,
  },
  {
    actionType: StatsConstants.Events.CLICKED_START_TRIAL_PA_UPSELL_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.logClickedStartTrialPAUpsellCoachmark,
  },
  {
    actionType: D.Constants.ViewActions.HOVERED_OVER_STATION_LIST,
    concur: 'takeEvery',
    handler: StatsWorkers.onStationListHovered,
  },
  {
    actionType: D.Constants.Playback.ActionTypes.IS_STATION_NARRATIVE_DISPLAYED,
    concur: 'takeEvery',
    handler: StatsWorkers.onStationNarrativeDisplayed,
  },
  {
    actionType: D.Constants.ViewActions.OPEN_SIGNUP_LOGIN_MODAL,
    concur: 'takeEvery',
    handler: StatsWorkers.onOpenSignupLoginModal,
  },
  {
    actionType: D.Constants.Ads.Video.Actions.FLEX_VIDEO_OPENED_RESUME_MODAL,
    concur: 'takeEvery',
    handler: StatsWorkers.logOpenedPAResumeCoachmark,
  },
  {
    actionType: D.Constants.Ads.Video.Actions.FLEX_VIDEO_RESUMED_FROM_MODAL,
    concur: 'takeEvery',
    handler: StatsWorkers.logResumedFromPAResumeCoachmark,
  },
  {
    actionType: D.Constants.Ads.Video.Actions.FLEX_VIDEO_HAS_DISMISSED,
    concur: 'takeEvery',
    handler: StatsWorkers.logDismissedFromPAResumeCoachmark,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.CLOSE_REWARDS_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.onCloseRewardsCoachmark,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.PLAY_REWARDS_AD,
    concur: 'takeEvery',
    handler: StatsWorkers.logCTAPremiumAccessCoachmark,
  },
  {
    actionType: D.Constants.Ads.Rewards.ActionTypes.SET_OPEN_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.onSetOpenCoachmark,
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.COMPONENT_VIEWED,
    concur: 'takeEvery',
    handler: StatsWorkers.logFTUXCoachmarkViewed,
  },
  {
    actionType: D.Constants.Overlay.OVERLAY_ACTIONS.COACHMARK_CLICKED,
    concur: 'takeEvery',
    handler: StatsWorkers.logFTUXCoachmarkClicked,
  },
  {
    actionType: D.Constants.App.AppActions.OPEN_AD_BLOCKER_MODAL,
    concur: 'takeEvery',
    handler: StatsWorkers.logAdBlockerModalEvent,
  },
  {
    actionType: D.Constants.App.AppActions.SET_IS_AD_BLOCKER_DETECTED,
    concur: 'takeEvery',
    handler: StatsWorkers.logAdBlockerDetected,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.UPDATE,
    concur: 'takeOnce',
    handler: StatsWorkers.handleAudioLifecycleEventsOnAppLaunch,
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.TRACK_STARTED_FROM_SOURCE,
    concur: 'takeLatest',
    handler: StatsWorkers.handleAudioLifecycleEvents,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.logAudioTrackPlay,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_VOICE_TRACK_METRIC,
    concur: 'takeEvery',
    handler: StatsWorkers.logVoiceTrackMetric,
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.TRACK_INTERRUPTED,
    concur: 'takeEvery',
    handler: StatsWorkers.onTrackInterrupted,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.SKIP_TRACK_FORWARD_CANCEL,
    concur: 'takeEvery',
    handler: TTMWorkers.handleSkipCancel,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
    concur: 'takeEvery',
    handler: TTMWorkers.handleStop,
  },
  {
    actionType: [
      D.Constants.Analytics.ActionTypes.LOG_RECENTLY_PLAYED_CAROUSEL_EVENT,
      D.Constants.SourceCard.ActionTypes.SOURCE_CARD_OPENED,
      D.Constants.SourceCard.ActionTypes.SOURCE_CARD_OPTION_CLICKED,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.logRecentlyPlayedCarouselEvent,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_CONCERT_NOTIFICATION_SENT,
    concur: 'takeEvery',
    handler: StatsWorkers.onLogConcertNotificationSent,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_CONCERT_NOTIFICATION_VIEWED,
    concur: 'takeEvery',
    handler: StatsWorkers.onLogConcertNotificationViewed,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_PLAYBACK_INTERACTIONS,
    concur: 'takeEvery',
    handler: ({ payload }) => StatsWorkers.logPlaybackInteractions(payload),
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_AD_BLOCKER_HAMMER_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.logAdBlockerHammerModalEvent,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_AD_BLOCKER_AUDIO_MESSAGE_COACHMARK,
    concur: 'takeEvery',
    handler: StatsWorkers.logAdBlockerAudioMessageCoachmark,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_CONCERT_NOTIFICATION_CLICKED,
    concur: 'takeEvery',
    handler: StatsWorkers.onLogConcertNotificationClicked,
  },
  {
    actionType: D.Constants.Analytics.ActionTypes.LOG_CONCERT_NOTIFICATION_NO_LONGER_ON_PAGE,
    concur: 'takeEvery',
    handler: StatsWorkers.onLogConcertNoLongerOnPage,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.CHANGE_INTERACTIVE_RADIO_MODE,
    concur: 'takeEvery',
    handler: StatsWorkers.logDiscoveryTunerAction,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.PAGE_RENDERED,
    concur: 'takeEvery',
    handler: StatsWorkers.logPageRendered,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.LINK_CLICKED,
    concur: 'takeEvery',
    handler: StatsWorkers.logLinkClicked,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.COMPONENT_SCROLLED,
    concur: 'takeEvery',
    handler: StatsWorkers.logDiscoveryTunerScrolled,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.LOG_API_ERROR_SHOWN,
    concur: 'takeEvery',
    handler: StatsWorkers.logAPIErrorMessage,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.OPEN_ERROR_TOAST,
    concur: 'takeEvery',
    handler: StatsWorkers.logToastErrorMessage,
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.ACTION_THUMB_UP_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_THUMB_DOWN_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_REMOVE_THUMB_SUCCESS,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.onAddRemoveThumb,
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.ADD_FEEDBACK_SUCCESS,
      D.Constants.Api.ApiActions.DELETE_FEEDBACK_SUCCESS,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.onAddDeleteFeedback,
  },
  {
    actionType: D.Constants.Playback.ActionTypes.SET_OR_CREATE_STATION_FINISHED,
    concur: 'takeEvery',
    handler: StatsWorkers.logStationReady,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.SET_SOURCE_REPEAT_MODE,
    concur: 'takeEvery',
    handler: StatsWorkers.onSetSourceRepeatMode,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.SKIP_TRACK_FORWARD,
    concur: 'takeEvery',
    handler: StatsWorkers.onSkipTrackForward,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.SKIP_TRACK_BACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onSkipTrackBack,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.SET_SOURCE_SHUFFLE_MODE,
    concur: 'takeEvery',
    handler: StatsWorkers.onSetSourceShuffleMode,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.SCRUB_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onScrubTrack,
  },
  {
    actionType: D.Constants.Playback.ActionTypes.INTENT_PLAY_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.onIntentPlayTrack,
  },
  {
    actionType: D.Constants.ViewActions.OPEN_DROPDOWN,
    concur: 'takeEvery',
    handler: StatsWorkers.onOpenDropdown,
  },
  {
    actionType: D.Constants.ViewActions.SHOWED_SHARE_MODAL,
    concur: 'takeEvery',
    handler: StatsWorkers.onOpenShareModal,
  },
  {
    actionType: D.Constants.Share.ShareActions.SHARE_OPTION_CLICKED,
    concur: 'takeEvery',
    handler: StatsWorkers.onShareOptionClicked,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.NAVIGATE_TO_BUSINESSES,
    concur: 'takeEvery',
    handler: StatsWorkers.logBusinessesEvent,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.NAVIGATE_TO_COMMUNITY,
    concur: 'takeEvery',
    handler: StatsWorkers.logCommunityEvent,
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.COMMUNITY_LOGOUT,
    concur: 'takeEvery',
    handler: StatsWorkers.logCommunityEvent,
  },
  {
    actionType: [
      D.Constants.SourceCard.ActionTypes.SOURCE_CARD_OPENED,
      D.Constants.SourceCard.ActionTypes.SOURCE_CARD_OPTION_CLICKED,
    ],
    concur: 'takeEvery',
    handler: StatsWorkers.onSourceCardEvent,
  },
  {
    actionType: D.Constants.Playback.APSActions.LOG_APS_ERROR,
    concur: 'takeEvery',
    handler: StatsWorkers.logApsError,
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.COMPONENT_CLICKED,
    concur: 'takeEvery',
    handler: StatsWorkers.logBrowseClickEvent,
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.IMAGE_FETCH_ERRORED,
    concur: 'takeEvery',
    handler: StatsWorkers.logImageFetchError,
  },
  {
    actionType: D.Constants.Playback.ActionTypes.PLAYBACK_LOG_START_PLAYING,
    concur: 'takeOnce',
    handler: StatsWorkers.logStartPlayingEvent,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
    concur: 'takeEvery',
    handler: StatsWorkers.logAudioPlayerTTAEvent,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYBACK_METRICS,
    concur: 'takeEvery',
    handler: StatsWorkers.logAudioTrackFullMetrics,
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.GRAPHQL_FETCHED,
    concur: 'takeEvery',
    handler: StatsWorkers.logGraphQLDuration,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.ERROR,
    concur: 'takeEvery',
    handler: StatsWorkers.logAudioPlayerError,
  },
  {
    actionType: [
      D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
      D.Constants.AudioPlayer.AudioPlayerActions.PAUSED,
      D.Constants.AudioPlayer.AudioPlayerActions.ENDED,
      D.Constants.AudioPlayer.AudioPlayerActions.SCRUB_AUDIO,
    ],
    concur: 'takeEvery',
    handler: AudioPlayerStatsWorkers.togglePlayheadWatcher,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
    concur: 'takeEvery',
    handler: StatsWorkers.updatePreviousPlayedHarness,
  },
  {
    actionType: StatsConstants.StatsActions.BUFFERING_START,
    concur: 'takeEvery',
    handler: BufferingWorkers.bufferingStart,
  },
  {
    actionType: D.Constants.App.AppActions.TRY_POKING_NETWORK,
    concur: 'takeOnce',
    handler: StatsWorkers.logWebPingRadioHealthExposureEvent,
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
    concur: 'takeOnce',
    handler: StatsWorkers.startDetectorLogging,
  },
  {
    actionType: D.Constants.Ads.Audio.Actions.LOG_SKIPPABILITY_EXPOSURE_EVENT,
    concur: 'takeOnce',
    handler: StatsWorkers.logAudioAdSkippabilityExposureEvent,
  },
  {
    actionType: D.Constants.Ads.Audio.Actions.LOG_OM_SDK_EXPOSURE_EVENT,
    concur: 'takeOnce',
    handler: StatsWorkers.logOmSdkExposureEvent,
  },
  {
    actionType: D.Constants.Ads.Actions.LOG_APS_MM4_EXPOSURE_EVENT,
    concur: 'takeOnce',
    handler: StatsWorkers.logApsMM4ExposureEvent,
  },
];
